import "./Calculette_s.css";

const Calculette_s = ({ children }) => {
    return <div className="calculatrice_s">{children}</div>;
};

export default Calculette_s;